export default function Footer() {
  return (
    <footer className="bg-black text-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          {/* Left Area - Brand */}
          <div>
            <h4 className="text-4xl font-bold mb-6">SLOZNA BRACA</h4>
            <p className="text-base text-gray-400 leading-relaxed mb-8">
              Your trusted partner in digital security and privacy protection
            </p>
            <div className="flex items-center gap-5">
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center hover:border-teal-500 hover:bg-teal-500/10 transition-all cursor-pointer"
              >
                <i className="ri-linkedin-line text-lg"></i>
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center hover:border-teal-500 hover:bg-teal-500/10 transition-all cursor-pointer"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center hover:border-teal-500 hover:bg-teal-500/10 transition-all cursor-pointer"
              >
                <i className="ri-facebook-line text-lg"></i>
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center hover:border-teal-500 hover:bg-teal-500/10 transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Middle Area - Contact */}
          <div>
            <h5 className="text-xs font-bold uppercase tracking-wider mb-5">CONTACT</h5>
            <div className="space-y-4 text-sm text-gray-400">
              <p>Doverska 15<br />Split 21000, Croatia</p>
              <p>+1 3082484339</p>
              <p>info@sloznabracadoo.com</p>
            </div>
          </div>

          {/* Right Area - Quick Links */}
          <div>
            <h5 className="text-xs font-bold uppercase tracking-wider mb-5">QUICK LINKS</h5>
            <div className="space-y-4 text-sm text-gray-400">
              <a href="#privacy" className="block hover:text-teal-500 transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#terms" className="block hover:text-teal-500 transition-colors cursor-pointer">Terms of Service</a>
              <a href="#support" className="block hover:text-teal-500 transition-colors cursor-pointer">Support</a>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500">
              © 2025 SLOZNA BRACA, d.o.o. All rights reserved
            </p>
            <div className="flex items-center gap-6">
              <p className="text-sm text-gray-500">Made in Croatia</p>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-sm text-gray-500 hover:text-teal-500 transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
